
  /* Size */
  .responsive2284599289__root .Text3127536861__root.Text3127536861---size-4-tiny {
  font-size: 11px;
  line-height: 16px;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---size-5-small {
  font-size: 12px;
  line-height: 16px;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---size-6-medium {
  font-size: 14px;
  line-height: 20px;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---size-5-large {
  font-size: 16px;
  line-height: 24px;
  }

  /* Skin */
  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-8-standard {
    color: #000624;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-14-standard-light {
    color: #ffffff;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-11-placeholder {
    color: #868aa5;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-7-premium {
    color: #5a48f5;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-5-alert {
    color: #ee4437;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-7-success {
    color: #25a55a;
  }

  /* TODO - remove in favor of TextButton */
  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-4-link {
    color: #116dff;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-9-secondary {
    color: #595d70;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861---skin-15-secondary-light {
    color: #f4f5f8;
  }

  .responsive2284599289__root .Text3127536861__root.Text3127536861--disabled {
    color: #bebebe;
  }

/* st-namespace-reference="../../../../src/atoms/Text/Text.responsive.st.css" */